module.exports = __webpack_public_path__ + "static/media/middle-middle-3.adb9e73f.png";